/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

import { Box, Flex, Text } from "@chakra-ui/react";
import { getContextMenuPosition } from "utils/contextMenuPosition";

function SimContextMenu({
  position,
  sim,
  onClose,
  onToggleRoaming,
  onSetDurumHazir,
  onShowAllNotes,
  onEditIdentifiers,
}) {
  if (!position || !sim) return null;
  const menuPosition = getContextMenuPosition(position, { menuWidth: 260, menuHeight: 340 });

  const isRoamingActive = (sim.roaming || "").toLowerCase() === "aktif";
  const toggleLabel = isRoamingActive ? "Roaming'i Pasif Yap" : "Roaming'i Aktif Et";
  const isBosaCikan = sim.durum === "bosa_cikan";

  return (
    <Box
      position="fixed"
      top={`${menuPosition.y}px`}
      left={`${menuPosition.x}px`}
      bg="white"
      borderRadius="lg"
      boxShadow="0 6px 18px rgba(0, 0, 0, 0.15)"
      zIndex={2000}
      onMouseLeave={onClose}
      minW="180px"
      fontSize="12px"
      border="1px solid rgba(0, 0, 0, 0.08)"
    >
      <MenuItem
        label="Tüm notları göster"
        description="Kullanım geçmişi ve tüm notlar"
        onClick={() => onShowAllNotes?.(sim)}
      />
      <MenuItem
        label="IMSI / ICCID düzenle"
        description="Manuel düzeltme (envanter)"
        onClick={() => onEditIdentifiers?.(sim)}
      />
      <MenuItem
        label={toggleLabel}
        description={`ICC ID: ${sim.iccid || "-"}`}
        onClick={() => onToggleRoaming?.(sim, !isRoamingActive)}
      />
      {isBosaCikan && (
        <MenuItem
          label="Durumu Hazır'a Çek"
          description="SIM durumunu 'hazir' yap"
          onClick={() => onSetDurumHazir?.(sim)}
        />
      )}
    </Box>
  );
}

function MenuItem({ label, description, onClick }) {
  return (
    <Flex
      direction="column"
      px={3}
      py={2}
      cursor="pointer"
      borderRadius="md"
      mx={1}
      transition="all 0.15s ease"
      _hover={{
        bg: "gray.50",
        color: "gray.900",
        transform: "scale(1.01)",
      }}
      onClick={onClick}
    >
      <Text fontWeight="600" fontSize="12px">
        {label}
      </Text>
      {description && (
        <Text fontSize="11px" color="gray.500">
          {description}
        </Text>
      )}
    </Flex>
  );
}

export default SimContextMenu;
